module.exports = __webpack_public_path__ + "static/open-sans-bold-1f85e92d8ff443980bc0f83ad7b23b60.woff";